import React                              from 'react';
import {createTheme, responsiveFontSizes} from '@mui/material';

const fontFamily = [
	// 'Roboto',
	// 'Do Hyeon',
	// 'Poor Story',
	// 'Gowun Dodum',
	// 'IBM Plex Sans KR',
	'Noto Sans KR',
	'Nanum Gothic',
	// 'sans-serif'
	// '-apple-system','BlinkMacSystemFont','Apple SD Gothic Neo','Malgun Gothic','맑은 고딕','arial','굴림','Gulim','sans-serif','Godo'
].join(',');

declare module '@mui/material/styles' {
	interface TypographyVariants {
		poster: React.CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		poster?: React.CSSProperties;
	}

	interface Palette {
		neutral: Palette['primary'];
		whiteOutlined: Palette['primary'];
	}

	// allow configuration using `createTheme`
	interface PaletteOptions {
		neutral?: PaletteOptions['primary'];
		whiteOutlined?: PaletteOptions['primary'];
	}
}

// Update the Button's color prop options
declare module '@mui/material/Button' {
	interface ButtonPropsColorOverrides {
		neutral: true;
		whiteOutlined: true;
	}
}

const sharedTypography = {
	fontFamily: fontFamily,
	fontSize: 12,
};

export let lightTheme: any = createTheme({
	palette: {
		mode: 'light',
		neutral: {
			main: '#636363',
			contrastText: '#fff',
		},
		whiteOutlined: {
			main: '#404040',
			contrastText: '#ffffff',
		},
		primary: {
			main: '#5383EC',
		},
		secondary: {
			main: '#f1f3f4',
		},
		text: {
			primary: '#1a1a1a',
			secondary: '#787878',
		},
		background: {
			default: '#ffffff',
			paper: '#ffffff',
		},
		divider: '#b8b8b8',
	},

	typography: sharedTypography,
});
lightTheme = responsiveFontSizes(lightTheme);

export let darkTheme: any = createTheme({
	palette: {
		mode: 'dark',
		neutral: {
			main: '#9a9a9a',
			contrastText: '#1a1a1a',
		},
		whiteOutlined: {
			main: '#9a9a9a',
			contrastText: '#1a1a1a',
		},
		primary: {
			main: '#7aa6ff',
		},
		secondary: {
			main: '#2d3035',
		},
		text: {
			primary: '#e6e6e6',
			secondary: '#a6a6a6',
		},
		background: {
			default: '#121212',
			paper: '#1e1e1e',
		},
		divider: '#3a3a3a',
	},

	typography: sharedTypography,
});
darkTheme = responsiveFontSizes(darkTheme);

export type ThemeMode = 'light' | 'dark';

export const getThemeByMode = (mode: ThemeMode) =>
	mode === 'dark' ? darkTheme : lightTheme;
